module.exports = __webpack_public_path__ + "img/jazzcash-logo.2f928365.png";